import base from './base.json';
import accounts from './accounts.json';
import sidebar from './sidebar.json';
import settings from './settings.json';
import ranking from './ranking.json';
import rank from './rank.json';
import challenges from './challenges.json';
import notify from './notify.json';
import report from './report.json';
import affiliation from './affiliation.json';
import metrix from './metrix.json';
import tradingTerminal from './tradingTerminal.json';
import risk from './risk.json';
import copyPositions from './copyPositions.json';
import support from './support.json';
import auth from './auth.json';
import economicTerminal from './economicTerminal.json';
import quant from './quant.json';
import propfirms from './propfirms.json';
import communities from './communities.json';
import moderation from './moderation.json';
import chart from './chart.json';

export default {
  base,
  accounts,
  sidebar,
  settings,
  ranking,
  rank,
  challenges,
  notify,
  report,
  affiliation,
  metrix,
  tradingTerminal,
  risk,
  copyPositions,
  support,
  auth,
  economicTerminal,
  propfirms,
  quant,
  communities,
  moderation,
  chart,
};
